document.addEventListener('DOMContentLoaded', function () {
  'use strict';
  var wrap = document.querySelector('[data-ar29-cart-pair]');
  if (!wrap) return;
  var dialog = wrap.querySelector('[data-ar29-pair-dialog]');
  var select = wrap.querySelector('[data-ar29-variant-select]');
  var add = wrap.querySelector('[data-ar29-pair-add]');
  var feedback = wrap.querySelector('[data-ar29-pair-feedback]');
  var key = 'ar30_pair_seen_' + wrap.dataset.pairHandle + '_' + wrap.dataset.cartCount;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function open() {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
  }
  function close() { if (dialog && dialog.open) dialog.close(); }
  wrap.querySelectorAll('[data-ar29-pair-close]').forEach(function (button) { button.addEventListener('click', close); });
  wrap.querySelectorAll('[data-ar29-pair-open]').forEach(function (button) { button.addEventListener('click', open); });
  if (dialog) dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
  if (select && add) select.addEventListener('change', function () {
    add.disabled = !Number(select.value);
    if (feedback) feedback.textContent = '';
  });
  if (dialog) {
    var seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (!seen) {
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
      open();
    }
  }
  if (add) add.addEventListener('click', function () {
    var id = select && Number(select.value);
    if (!id) { if (feedback) feedback.textContent = 'Bitte wähle zuerst eine Größe.'; if (select) select.focus(); return; }
    add.disabled = true;
    if (feedback) feedback.textContent = 'Wird zum Warenkorb hinzugefügt …';
    fetch(root + 'cart/add.js', { method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:id,quantity:1}]})
    }).then(function (r) { if (!r.ok) throw Error('Add failed'); return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        if (feedback) feedback.textContent = 'Das hat nicht geklappt. Bitte öffne den Artikel und versuche es erneut.';
        add.disabled = false;
      });
  });
});